import request from '@/utils/request';
import { hasMinimumLength } from '@/utils/resultsHelper';
import { endpoints, roleEndpoint, updateRoleEndpoint } from '@/constants/urls';

const roles = (category, filter, includeUsers, includeTokens, page, pageSize, assignable) => {
  const params = { filter, page, pageSize };
  const url = category === 'tokens' ? endpoints.TOKEN_ROLES : endpoints.ROLES;

  if (includeUsers) {
    params.users = true;
  }
  if (includeTokens) {
    params.tokens = true;
  }
  if (assignable) {
    params.assignable = true;
  }

  return (
    request({
      url,
      params,
      method: 'GET',
    })
  );
};

const role = (code) => request({
  url: roleEndpoint(code),
  method: 'GET',
});

const create = ({
  code, name, description, grouping,
}, maxActive, maxDays, permissions) => {
  const data = {
    code,
    name,
    description,
    grouping,
    permissions,
    max_active_tokens: maxActive,
    max_token_length_days: maxDays,
  };

  if (!hasMinimumLength(data.code)) {
    delete data.code;
  }

  return request({
    url: endpoints.ROLES,
    data,
    method: 'POST',
  });
};

const update = ({
  code,
  name,
  description,
  permissions,
}, maxActive, maxDays) => request({
  url: roleEndpoint(code),
  data: {
    name,
    description,
    permissions,
    max_active_tokens: maxActive,
    max_token_length_days: maxDays,
  },
  method: 'PUT',
});

const updateRole = (
  code,
  uuid,
) => request({
  url: updateRoleEndpoint(code),
  data: {
    users: [{ uuid }],
  },
  method: 'PATCH',
});

const RolesService = {
  roles,
  role,
  create,
  update,
  updateRole,
};

export default RolesService;
